(function iefe(w, d) {
    const search = d.querySelector('.HeaderSearch--desktop');
    const form = search.querySelector('form');
    const button = search.querySelector('.HeaderSearch__button');
    const blade = search.querySelector('.HeaderSearch .Search__input');
    const header = d.querySelector('.Header');

    function openSearch() {
        header.classList.add('Header--search-open');
        blade.focus();
    }
    function closeSearch() {
        header.classList.remove('Header--search-open');
    }

    /* open Search with button */
    button.addEventListener('click', () => {
        openSearch();
    });

    /* close Search if clicked outside */
    w.addEventListener('click', (e) => {
        if (e.target !== search && !search.contains(e.target)) {
            closeSearch();
        }
    });

    /* close Search if clicked outside */
    w.addEventListener('click', (e) => {
        if (e.target !== search && !search.contains(e.target)) {
            closeSearch();
        }
    });

    /* close Search if ESC */
    w.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeSearch();
        }
    });

    /* close Search when it loses focus */
    form.addEventListener('focusout', (e) => {
        if (!form.contains(e.relatedTarget)) {
            closeSearch();
            button.focus();
        }
    });
}(window, document));
